import React from 'react';
import { Link, Trans, useTranslation } from 'gatsby-plugin-react-i18next';
import * as styles from './404.module.css';
import Layout from '../components/layout';
import SEO from '../components/seo';
import PageNotFound from '../images/not-found-illu.svg';

function NotFound() {
  const { t } = useTranslation('notfound');

  return (
    <Layout>
      <SEO
        title={t('meta.title')}
        description={t('meta.description')}
      />
      <main className={styles.main}>
        <h1 className={styles.header}>
          <Trans
            i18nKey="notfound:header"
            components={{ bold: <b /> }}
          />
        </h1>
        <img
          aria-hidden
          className={styles.image}
          src={PageNotFound}
          alt={t('whiteWavesAlt')}
        />
        <p className={styles.forwarder}>
          <Trans i18nKey="notfound:forwarder">
            You can return to homepage by <Link to="/">clicking here</Link>. {/* eslint-disable-line react/jsx-one-expression-per-line */}
          </Trans>
        </p>
      </main>
    </Layout>
  );
}

export default NotFound;
